import { useMutation } from "@shared/lib/hooks";
import { ToastService } from "@shared/lib/services";
import { CampaignService } from "../services/Campaign.service";
import { ICreateInvoice, IEditInvoice } from "@shared/lib/types/briefCampains";
import { FINANCE_INFLUENCER_QUERY_KEY } from "../contsants";

export function useEditInvoice(campaignInfluencerId: string) {
  const {
    mutate: editInvoice,
    isLoading: isEditing,
    isSuccess: isEdited,
  } = useMutation<IEditInvoice>({
    mutationFn: async (invoice) => {
      return await CampaignService.editInvoice(invoice).catch(async (err) => {
        const responseBody = await err.response.json();
        ToastService.error(responseBody.msg);
        throw err;
      });
    },
    onSuccess: (c) => {
      c.invalidateQueries({
        queryKey: [...FINANCE_INFLUENCER_QUERY_KEY(campaignInfluencerId)],
      });
      // TODO: Invalidate relevant queries here
    },
    options: {},
  });

  return {
    editInvoice,
    isEditing,
    isEdited,
  };
}
